import { useCreateTeamMutation, CreateTeamRequest } from 'src/api/redux/teams';

export const useCreateTeam = () => {
  const [createTeamMutation, { isLoading: isCreating, error }] =
    useCreateTeamMutation();

  const handleCreateTeam = async (data: CreateTeamRequest) => {
    try {
      const result = await createTeamMutation(data).unwrap();
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: err };
    }
  };

  return {
    createTeam: handleCreateTeam,
    isCreating,
    error: error ? { message: (error as { data?: { detail?: string } })?.data?.detail || 'An error occurred' } : null,
  };
};

export default useCreateTeam;
